import React from "react";
import styles from "./SlidingHeaderMenu.module.scss";
import classNames from "classnames";
import SlidingMenu from "./SlidingMenu";
import {PopoverContext} from "../Popover";

export default ({title, Icon, ActionButton, HeaderContents, children, isActive, closeTrigger, className, containerClassName, maskClassName, top, Footer, contentClassName}) => {
    return (
        <SlidingMenu top={top} isActive={isActive} closeTrigger={closeTrigger} className={containerClassName} maskClassName={maskClassName}>
            <div className={classNames(styles.base, className)}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        {Icon && <Icon className={styles.icon}/>}
                        <span>{title}</span>
                    </div>
                    {ActionButton && <ActionButton className={styles['action-button']}/>}
                    {HeaderContents && <HeaderContents/>}
                </div>
                <PopoverContext className={classNames(styles['container'], contentClassName)}>
                    {children}
                </PopoverContext>
                {Footer && <Footer/>}
            </div>
        </SlidingMenu>
    );
};

